export default __webpack_public_path__ + "static/media/purple_pawn.5790838f.png";